import { config } from '../config';
import { authHeader } from '../helpers';
import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: '' // your base URL if needed
});

// 🔥 GLOBAL RESPONSE HANDLER
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      localStorage.removeItem('user');

      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }

      // ✅ STOP propagation completely
      return new Promise(() => {});
    }

    return Promise.reject(error);
  }
);

export const vehiclesService = {
  getVehiclesForGuidance
};

function getVehiclesForGuidance() {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };

  return axiosInstance
    .get(`${config.vehicle_server}/guidance`, requestOptions)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
}
